import { z } from "zod";
import { EServiceCategory, EServiceType } from "./common";
import { userBasicPublicInfoSchema } from "./user";
import { partnerResponseDtoSchema } from "./partner";
import { AdminTaskResponseDto } from "./task";
import { ModifySessionReason } from "../constants/session.constants";

export const partnerBasePayTaskDataSchema = z.object({
    partner: partnerResponseDtoSchema,
    user: userBasicPublicInfoSchema.nullish(),
    scheduledAt: z.number(),
    serviceCategory: z.nativeEnum(EServiceCategory),
    serviceType: z.nativeEnum(EServiceType),
    createdAt: z.number(),
    city: z.string(),
    productId: z.string(),
    variantId: z.string(),
    ruleCode: z.string(),
    amount: z.number(),
    cancellationReason: z.nativeEnum(ModifySessionReason).nullish(),
    sessionId: z.string().nullish(),
});

export type PartnerBasePayTaskResponseDto = z.infer<typeof partnerBasePayTaskDataSchema>;

export type IPartnerBasePay = AdminTaskResponseDto<PartnerBasePayTaskResponseDto>;


